import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=c8fe82fe&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8fe82fe')) {
      api.createRecord('c8fe82fe', component.options)
    } else {
      api.reload('c8fe82fe', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=c8fe82fe&", function () {
      api.rerender('c8fe82fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hSZt4Y2Pc75N/JS/comp/openstreetmap.vue"
export default component.exports